import { render, staticRenderFns } from "./ContainerDetails.vue?vue&type=template&id=55235412&scoped=true&"
import script from "./ContainerDetails.vue?vue&type=script&lang=js&"
export * from "./ContainerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContainerDetails.vue?vue&type=style&index=0&id=55235412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55235412",
  null
  
)

export default component.exports